import { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import logos from "../assets/img/Software logo's";
import useInView from "../utils/useInView";
import "./Services.css";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5, // Adjust the stagger duration as needed
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6, // Adjust the animation duration as needed
      ease: "easeInOut",
    },
  },
};

const LogosComponent = () => {
  const ref = useRef(null);
  const isInView = useInView(ref);

  return (
    <motion.div
      className="logo-container"
      variants={containerVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      ref={ref}
    >
      {" "}
      {Object.entries(logos).map(([key, logo]) => (
        <motion.div className="logo-wrapper" key={key} variants={itemVariants}>
          {" "}
          <img src={logo} alt={`Logo ${key}`} className="logo-icon" />{" "}
        </motion.div>
      ))}{" "}
    </motion.div>
  );
};

const Services = () => {
  return (
    <section className="services" id="services">
      <Container>
        <Row>
          <Col xs={12} md={6} xl={6} className="left-col">
            <h2> Services</h2>
            <h3> What can I offer you?</h3>
            <p> I can offer you help with any software related project.</p>
            <p>
              {" "}
              I am an AI software developer with a passion for applied robotics research - exploring how computer vision and on-device AI can make machines genuinely intelligent.
              But with my broad software engineering degree I can cover the basics for almost all topics. {" "}
            </p>{" "}
            <p>
              {" "}
              From robotics research to project management, to web development to embedded software
              development,.. you can always contact me :)
            </p>
          </Col>
          <Col xs={12} md={5} xl={5} className="right-col">
            <p className="skill-text">Software skills that I already have: </p>
            <LogosComponent />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;
